import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    FRONT_TEMPORADAS_RECINTO_BUTACAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.temporada.recinto.butacas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_TEMPORADAS_RECINTO_REGIONES_ANEXAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.temporada.recinto.regiones.anexas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_TEMPORADAS_RECINTO_REGIONES_ANEXAS_BUTACAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.temporada.recinto.regiones.anexas.butacas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_TEMPORADAS_RECINTO_REGIONES_ANEXAS_SVG: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.temporada.recinto.regiones.anexas.svg'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_TEMPORADAS_SEGUNDOS_DISPONIBLE: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.temporada.segundos.disponible'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_TEMPORADA_RECINTO_SECCIONES: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.temporada.recinto.secciones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_TEMPORADA_RECINTO_SECCIONES_SVG: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.temporada.recinto.secciones.svg'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_TEMPORADA_RECINTO_SECCIONES_ZONAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.temporada.recinto.secciones.zonas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_TEMPORADA_RECINTO_SECCIONES_ZONAS_SVG: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.temporada.recinto.secciones.zonas.svg'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_TEMPORADA_PRECIOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.temporada.precios'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
}

export default {
    actions
};
